export default [
  {
    path: '/privacy-web',
    name: 'privacy-web',
    component: () => import('@/views/docsify/privacyWeb'),
    meta: {
      title: 'web隐私协议|图片编辑助手'
    }
  },
  {
    path: '/privacy-ios',
    name: 'privacy-ios',
    component: () => import('@/views/docsify/privacyIos'),
    meta: {
      title: 'iOS隐私协议|图片编辑助手'
    }
  },
  {
    path: '/privacy-ios-international',
    name: 'privacy-ios-international',
    component: () => import('@/views/docsify/privacyIosInternational'),
    meta: {
      title: 'Privacy Policy | ImgMeta'
    }
  },
  {
    path: '/user-ios',
    name: 'user-ios',
    component: () => import('@/views/docsify/userIos'),
    meta: {
      title: 'iOS用户服务协议|图片编辑助手'
    }
  },
  {
    path: '/user-ios-international',
    name: 'user-ios-international',
    component: () => import('@/views/docsify/userIosInternational'),
    meta: {
      title: 'Terms of Use | ImgMeta'
    }
  },
  {
    path: '/privacy-ios-puzzle',
    name: 'privacy-ios-puzzle',
    component: () => import('@/views/docsify/privacyIosPuzzle'),
    meta: {
      title: 'iOS隐私协议|图片压缩-照片压缩专家'
    }
  },
  {
    path: '/privacy-ios-puzzle-international',
    name: 'privacy-ios-puzzle-international',
    component: () => import('@/views/docsify/privacyIosPuzzleInternational'),
    meta: {
      title: 'Privacy Policy | Pintu'
    }
  },
  {
    path: '/user-ios-puzzle',
    name: 'user-ios-puzzle',
    component: () => import('@/views/docsify/userIosPuzzle'),
    meta: {
      title: 'iOS用户服务协议|图片压缩-照片压缩专家'
    }
  },
  {
    path: '/user-ios-puzzle-international',
    name: 'user-ios-international',
    component: () => import('@/views/docsify/userIosPuzzleInternational'),
    meta: {
      title: 'Terms of Use | Pintu'
    }
  },
  {
    path: '/user-web',
    name: 'user-web',
    component: () => import('@/views/docsify/userWeb'),
    meta: {
      title: 'web用户服务协议|图片编辑助手'
    }
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: () => import('@/views/docsify/aboutUs'),
    meta: {
      title: '关于我们|图片编辑助手'
    }
  },
  {
    path: '/quick-app',
    name: 'quick-app',
    component: () => import('@/views/docsify/quickApp'),
    meta: {
      title: '快应用'
    }
  },
  {
    path: '/download-app',
    name: 'download-app',
    component: () => import('@/views/docsify/downloadApp'),
    meta: {
      title: '图片编辑助手'
    }
  },
  {
    path: '/download-ios',
    name: 'download-ios',
    component: () => import('@/views/docsify/downloadIos'),
    meta: {
      title: '下载App|图片编辑助手'
    }
  },
  {
    path: '/download-app-compress',
    name: 'download-app-compress',
    component: () => import('@/views/docsify/downCompressApp'),
    meta: {
      title: '照片图片压缩专家'
    }
  },
  {
    path: '/download-ios-compress',
    name: 'download-ios-compress',
    component: () => import('@/views/docsify/downCompressIos'),
    meta: {
      title: '下载App|照片图片压缩专家'
    }
  },
  {
    path: '/download-pdf',
    name: 'download-pdf',
    component: () => import('@/views/docsify/downPdfApp'),
    meta: {
      title: '倍明PDF编辑器'
    }
  },
  {
    path: '/download-ios-pdf',
    name: 'download-ios-pdf',
    component: () => import('@/views/docsify/downPdfIos'),
    meta: {
      title: '下载App|倍明PDF编辑器'
    }
  },
  {
    path: '/download-puzzle',
    name: 'download-puzzle',
    component: () => import('@/views/docsify/downPuzzleApp'),
    meta: {
      title: '拼图君'
    }
  },
  {
    path: '/download-ios-puzzle',
    name: 'download-ios-puzzle',
    component: () => import('@/views/docsify/downPuzzleIos'),
    meta: {
      title: '下载App|拼图君'
    }
  },
  {
    path: '/privacy-quick-app',
    name: 'privacy-quick-app',
    component: () => import('@/views/docsify/privacyQuickApp'),
    meta: {
      title: '隐私协议｜图片编辑助手'
    }
  },
  {
    path: '/privacy-pdf',
    name: 'privacy-pdf',
    component: () => import('@/views/docsify/privacyPdf'),
    meta: {
      title: '隐私协议｜倍明PDF编辑器'
    }
  },
  {
    path: '/user-pdf',
    name: 'user-pdf',
    component: () => import('@/views/docsify/userPdf'),
    meta: {
      title: '用户协议｜倍明PDF编辑器'
    }
  },
  {
    path: '/privacy-pdfmeta',
    name: 'privacy-pdfmeta',
    component: () => import('@/views/docsify/privacyPdfmeta'),
    meta: {
      title: '隐私协议｜PDFMeta-PDF转换器⽤户协议'
    }
  },
  {
    path: '/user-pdfmeta',
    name: 'user-pdfmeta',
    component: () => import('@/views/docsify/userPdfmeta'),
    meta: {
      title: '用户协议｜PDFMeta-PDF转换器⽤户协议'
    }
  },
  {
    path: '/app-share',
    name: 'app-share',
    component: () => import('@/views/docsify/appShare'),
    meta: {
      title: 'app分享'
    }
  },
  {
    path: '/app-img-meta-share',
    name: 'app-img-meta-share',
    component: () => import('@/views/docsify/appImgMetaShare'),
    meta: {
      title: 'app分享'
    }
  },
  {
    path: '/app-pdf-share',
    name: 'app-pdf-share',
    component: () => import('@/views/docsify/pdfShare'),
    meta: {
      title: 'app分享'
    }
  },
  {
    path: '/app-collage-share',
    name: 'app-collage-share',
    component: () => import('@/views/docsify/appCollageShare'),
    meta: {
      title: 'app分享'
    }
  },
  {
    path: '/img-segmentation',
    name: 'img-segmentation',
    component: () => import('@/views/docsify/imgSegmentation'),
    meta: {
      title: '抠图拼接使用说明'
    }
  },
  {
    path: '/app-privacy-policy',
    name: 'app-privacy-policy',
    component: () => import('@/views/docsify/appPrivacyPolicy'),
    meta: {
      title: '图片编辑助手隐私政策'
    }
  },
  {
    path: '/app-privacy-policy-img-meta',
    name: 'app-privacy-policy-img-meta',
    component: () => import('@/views/docsify/appPrivacyPolicyImgMeta'),
    meta: {
      title: 'ImgMeta图片压缩专家隐私政策'
    }
  },
  {
    path: '/app-privacy-policy-jigsaw-puzzle',
    name: 'app-privacy-policy-jigsaw-puzzle',
    component: () => import('@/views/docsify/appPrivacyPolicyJigsawPuzzle'),
    meta: {
      title: '拼图君隐私政策'
    }
  },
  {
    path: '/privacy-long-picture-stitching-expert',
    name: 'privacy-long-picture-stitching-expert',
    component: () => import('@/views/docsify/privacyLongPictureStitchingExpert'),
    meta: {
      title: '长图拼接专家隐私政策'
    }
  },
  {
    path: '/privacy-long-picture-stitching-expert-huawei',
    name: 'privacy-long-picture-stitching-expert-huawei',
    component: () => import('@/views/docsify/privacyLongPictureStitchingExpertHuawei'),
    meta: {
      title: '拼图君隐私政策'
    }
  },
  {
    path: '/privacy-img-meta-english',
    name: 'privacy-img-meta-english',
    component: () => import('@/views/docsify/privacyImgMetaEnglish'),
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/privacy-img-meta-taiwan',
    name: 'privacy-img-meta-taiwan',
    component: () => import('@/views/docsify/privacyImgMetaTaiWan'),
    meta: {
      title: 'ImgMeta圖片壓縮專家隱私政策'
    }
  },
  {
    path: '/privacy-img-meta-chinese',
    name: 'privacy-img-meta-chinese',
    component: () => import('@/views/docsify/privacyImgMetaChinese'),
    meta: {
      title: 'ImgMeta图片压缩专家隐私政策'
    }
  },
  {
    path: '/privacy-img-meta-zh',
    name: 'privacy-img-meta-zh',
    component: () => import('@/views/docsify/privacyImgMetaZh'),
    meta: {
      title: 'ImgMeta圖片壓縮專家隱私政策'
    }
  },
  {
    path: '/privacy-img-meta-en',
    name: 'privacy-img-meta-en',
    component: () => import('@/views/docsify/privacyImgMetaEn'),
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/permission-specification',
    name: 'permission-specification',
    component: () => import('@/views/docsify/PermissionSpecification'),
    meta: {
      title: '权限说明'
    }
  },
  {
    path: '/function-introduction',
    name: 'function-introduction',
    component: () => import('@/views/docsify/FunctionIntroduction'),
    meta: {
      title: '功能介绍'
    }
  }
]



// WEBPACK FOOTER //
// ./src/vue/router/modules/privacy.js